import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';


export const HELP_FLEX_INDICATORS = 'FLEX_INDICATORS';
export const HELP_CHAT_CHANNEL_ID = "CHAT_CHANNEL_ID";
export const HELP_SHEET = 'SHEET';
export const HELP_WEBHOOK = 'WEBHOOK';
export const HELP_GA4_THOU_SHEETS = 'GA4_THOU_SHEETS';
export const HELP_GA4 = 'GA4';
export const HELP_LOOKER_CC = 'LOOKER_CC';
export const HELP_DATA_NODE = 'DATA_NODE';
export const HELP_DATA_EXPLORER = 'DATA_EXPLORER';
export const HELP_MCP = 'MCP';
export const HELP_MCP_INTERNAL = 'MCP_INTERNAL';
export const HELP_NO_BUDGETS_ASSIGNED = 'NO_BUDGETS_ASSIGNED';
export const HELP_BU_CONFIGURATION_TYPES = 'BU_CONFIGURATION_TYPES';
export const HELP_FACEBOOK_FIXED_ACTIONS = "FACEBOOK_FIXED_ACTIONS";
export const HELP_DAILY_LIMIT = "DAILY_LIMIT";
export const HELP_IMPORT_CSV_FROM_BUCC = "IMPORT_CSV_FROM_BUCC";
export const HELP_ADMIN_AND_REGULAR_USERS = "ADMIN_AND_REGULAR_USERS";
export const HELP_INCLUDE_CAMPAIGNS_AUTOMATICALLY = "INCLUDE_CAMPAIGNS_AUTOMATICALLY";
export const HELP_BUDGET_PARTIAL_GOALS = "BUDGET_PARTIAL_GOALS";

const DATA_OF_ARTICLE = {
    [HELP_FLEX_INDICATORS]: {
        "url": "https://ayuda.dashbo.io/es/articles/8486415-columnas-personalizadas-en-tu-agencia"
    },
    [HELP_CHAT_CHANNEL_ID]: {
        "url": "https://ayuda.dashbo.io/es/articles/8554125-envio-de-alertas-y-notificaciones-por-chat-slack-discord-google-chat-y-mas#h_b738439470"
    },
    [HELP_SHEET] : {
        "url": "https://ayuda.dashbo.io/es/articles/8556847-configurar-una-google-sheet-como-fuente-de-datos-de-campanas"
    },
    [HELP_WEBHOOK] : {
        "url": "https://ayuda.dashbo.io/es/articles/8557907-enviar-alertas-y-notificaciones-a-un-webhook"
    },
    [HELP_GA4_THOU_SHEETS] : {
        "url": "https://ayuda.dashbo.io/es/articles/8884838-metricas-y-alertas-de-ga4-en-tus-presupuestos"
    },
    [HELP_LOOKER_CC] : {
        "url": "https://ayuda.dashbo.io/es/articles/11379867-conecta-dashbo-con-looker-studio"
    },
    [HELP_DATA_NODE] : {
        "url": "https://ayuda.dashbo.io/es/articles/11682862-nodo-de-datos"
    },
    [HELP_DATA_EXPLORER] : {
        "url": "/data-explorer"
    },
    [HELP_MCP] : {
        "url": "https://mcp.ai.dashbo.io/"
    },
    [HELP_MCP_INTERNAL] : {
        "url": "/dashbo-connect"
    },
    [HELP_GA4] : {
        "url": "https://ayuda.dashbo.io/es/articles/9897154-monitoreo-y-alarmas-con-metricas-de-ga4"
    },
    [HELP_NO_BUDGETS_ASSIGNED] : {
        "url": "https://ayuda.dashbo.io/es/articles/8569762-por-que-no-veo-ningun-presupuesto-en-el-tablero-principal"
    },
    [HELP_BU_CONFIGURATION_TYPES] : {
        "url": "https://ayuda.dashbo.io/es/articles/8660252-presupuesto-total-y-presupuesto-por-campana"
    },
    [HELP_FACEBOOK_FIXED_ACTIONS] : {
        "url": "https://ayuda.dashbo.io/es/articles/8148527-configurar-que-evento-considero-como-conversion-en-una-cuenta-de-meta-ads"
    },
    [HELP_DAILY_LIMIT]: {
        "url": "https://ayuda.dashbo.io/es/articles/8149954-evita-perder-el-dinero-de-tus-clientes-con-la-funcion-de-limite-diario"
    },
    [HELP_IMPORT_CSV_FROM_BUCC]: {
        "url": "https://ayuda.dashbo.io/es/articles/8777753-importar-presupuestos-desde-un-archivo-csv"
    },
    [HELP_ADMIN_AND_REGULAR_USERS]: {
        "url": "https://ayuda.dashbo.io/es/articles/9146361-diferencias-entre-usuarios-administradores-y-usuarios-regulares"
    },
    [HELP_INCLUDE_CAMPAIGNS_AUTOMATICALLY]: {
        "url": "https://ayuda.dashbo.io/es/articles/9641467-como-usar-la-opcion-incluir-automaticamente-campanas"
    },
    [HELP_BUDGET_PARTIAL_GOALS]: {
        "url": "https://ayuda.dashbo.io/es/articles/10394188-presupuestos-por-tramos"
    }
}

export const STYLE_WANT_TO_KNOW_MORE = "WANT_TO_KNOW_MORE";

export class LinkToArticleClass extends Component {
    getUrl() {
        const url = DATA_OF_ARTICLE[this.props.article]["url"]
        return url === undefined ? "#" : url;
    }

    renderText() {
        const { t } = this.props;
        if(this.props.text !== undefined && this.props.text !== null && this.props.text.length > 0) {
            return this.props.text;
        }

        if(this.props.type === STYLE_WANT_TO_KNOW_MORE) {
            return t('link_to_article.want_to_know_more');
        }

        return t('link_to_article.want_to_know_more');
    }

    render() {
        return <span className="ms-2 me-2 help_center_link"><a href={this.getUrl()} target="_blank">[{this.renderText()}]</a></span>
    }

    prefix() {
        if (this.props.prefix === undefined) {
            return 'fas'
        } else {
            return this.props.prefix
        }
    }
}

export const LinkToArticle = withTranslation()(LinkToArticleClass);
export default LinkToArticle;
